module.exports = __webpack_public_path__ + "img/hr-straight-rail-diagonal-left-bottom-backplates.80e1c6d0.png";